import { Change, AuditTrailTableData, ChangeType, Update } from '@/families/models/update';
import { FamilyHistoryUtils } from '@/families/family-history-utils';

const familyHistoryUtils = new FamilyHistoryUtils();

export function flattenUpdatesToChanges(updates: Array<Update>): Array<Change> {
    const allChanges: Array<Change> = [];
    updates.forEach(update => {
        if (update.changes) {
            allChanges.push(...update.changes);
        }
    });
    return allChanges;
}

/**
 * Search filter for audit trail table data
 */
export function filterAuditTrailBySearch(
    tableData: Array<AuditTrailTableData>,
    searchTerm: string,
    formatDate: (date: string) => string,
    formatTime: (date: string) => string
): Array<AuditTrailTableData> {
    if (!searchTerm || searchTerm.trim() === '') {
        return tableData;
    }

    const searchLower = searchTerm.toLowerCase().trim();

    return tableData.filter((item: AuditTrailTableData) => {
        const searchableText = [
            item.user,
            item.type,
            item.action,
            item.details,
            item.event_comment || '',
            formatDate(item.date) + ' ' + formatTime(item.date)
        ].join(' ').toLowerCase();

        return searchableText.includes(searchLower);
    });
}

/**
 * Map changes to audit trail table data
 * Note: Backend now handles full audit mode details via full_audit query parameter
 */
export function mapChangesToTableData(
    changes: Array<Change>,
    keyCounter: { value: number }
): Array<AuditTrailTableData> {
    return changes.map((change: Change) => ({
        icon: (change.field_changes.length > 0 || familyHistoryUtils.getChangeId(change) !== null) &&
            change.type !== ChangeType.STATUS
            ? 'mdi-eye'
            : '',
        id: keyCounter.value++,
        user: familyHistoryUtils.getChangeUser(change),
        date: change.type === ChangeType.TASK && change.action === 'Completed'
            ? change.action_date_time
            : change.date_time,
        type: change.type,
        action: change.action,
        details: change.details,
        event_comment: change.event_comment,
        change: change
    } as AuditTrailTableData));
}
